import { createFileRoute } from '@tanstack/react-router';
import { AssetDetailPage } from '../features/assets/asset-library-page';
export const Route = createFileRoute('/manage/$companySlug/assets_/$assetId')({
  component: RouteComponent,
});
function RouteComponent() {
  const { assetId, companySlug } = Route.useParams();
  return <AssetDetailPage assetId={assetId} companySlug={companySlug} />;
}
